// extracted by mini-css-extract-plugin
export default {"sohoContainer":"SOHO_sohoContainer__l-QDh"};